import qs from "qs";
import { type StaticClientConfig } from "@/staticClientConfig";
import { isAbsoluteURL } from "../url/isAbsoluteURL";

export function getImgixImageURL(
  src = "",
  imgixConfig: StaticClientConfig["imgix"],
  params = "",
) {
  const {
    host,
    article: { host: articleHost },
  } = imgixConfig;

  if (!src || isAbsoluteURL(src)) return null;

  const isGif = /\.gif$/i.test(src);

  const defaultParams = {
    auto: isGif ? "format,compress" : "format",
    fit: "max",
  };

  const customParams = {
    ...defaultParams,
    ...qs.parse(params),
  };

  const imgixParams = qs.stringify(customParams, {
    addQueryPrefix: true,
  });

  let imgixHost = host;
  if (/^\/images\/cacheable\//i.test(src)) {
    imgixHost = articleHost;
  }

  return `${imgixHost}${src}${imgixParams}`;
}
